import { render, staticRenderFns } from "./OhsHeader.vue?vue&type=template&id=e4dda1e2&scoped=true&"
import script from "./OhsHeader.vue?vue&type=script&lang=js&"
export * from "./OhsHeader.vue?vue&type=script&lang=js&"
import style0 from "./OhsHeader.vue?vue&type=style&index=0&id=e4dda1e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4dda1e2",
  null
  
)

export default component.exports